import type { RouteRecord } from "vite-react-ssg";
import Index from "./pages/Index";
import RootLayout from "./components/RootLayout";

// Import blog posts for static path generation
import { blogPosts } from "./data/blogPosts";

export const routes: RouteRecord[] = [
  {
    path: "/",
    Component: RootLayout,
    children: [
      {
        index: true,
        Component: Index,
      },
      {
        path: "validate",
        lazy: async () => {
          const { default: Component } = await import("./pages/MeshlyValidate");
          return { Component };
        },
      },
      {
        path: "intelligence",
        lazy: async () => {
          const { default: Component } =
            await import("./pages/MeshlyIntelligence");
          return { Component };
        },
      },
      {
        path: "cfolc-spring",
        lazy: async () => {
          const { default: Component } = await import("./pages/CFOLCSpring");
          return { Component };
        },
      },
      {
        path: "ima-2026",
        lazy: async () => {
          const { default: Component } = await import("./pages/IMA2026");
          return { Component };
        },
      },
      {
        path: "aicpa-2026",
        lazy: async () => {
          const { default: Component } = await import("./pages/AICPA2026");
          return { Component };
        },
      },
      {
        path: "about",
        lazy: async () => {
          const { default: Component } = await import("./pages/About");
          return { Component };
        },
      },
      {
        path: "privacy",
        lazy: async () => {
          const { default: Component } = await import("./pages/Privacy");
          return { Component };
        },
      },
      {
        path: "terms",
        lazy: async () => {
          const { default: Component } = await import("./pages/Terms");
          return { Component };
        },
      },
      {
        path: "validate-signup",
        lazy: async () => {
          const { default: Component } = await import("./pages/ValidateSignup");
          return { Component };
        },
      },
      {
        path: "validate-signup/thank-you",
        lazy: async () => {
          const { default: Component } =
            await import("./pages/ValidateSignupThankYou");
          return { Component };
        },
      },
      {
        path: "finance-advisory-board",
        lazy: async () => {
          const { default: Component } =
            await import("./pages/FinanceAdvisoryBoard");
          return { Component };
        },
      },
      {
        path: "finance-advisory-board/thank-you",
        lazy: async () => {
          const { default: Component } =
            await import("./pages/FinanceAdvisoryBoardThankYou");
          return { Component };
        },
      },
      {
        path: "finops-advisory-board",
        lazy: async () => {
          const { default: Component } = await import("./pages/FinOpsRedirect");
          return { Component };
        },
      },
      {
        path: "finops-advisory-board/thank-you",
        lazy: async () => {
          const { default: Component } = await import("./pages/FinOpsRedirect");
          return { Component };
        },
      },
      {
        path: "pricing",
        lazy: async () => {
          const { default: Component } = await import("./pages/Pricing");
          return { Component };
        },
      },
      {
        path: "blog",
        lazy: async () => {
          const { default: Component } = await import("./pages/Blog");
          return { Component };
        },
      },
      {
        path: "blog/:slug",
        lazy: async () => {
          const { default: Component } = await import("./pages/BlogPost");
          return { Component };
        },
        getStaticPaths: async () => {
          return blogPosts.map((post) => `/blog/${post.slug}`);
        },
      },
      {
        path: "report/cost-of-fragmentation",
        lazy: async () => {
          const { default: Component } = await import("./pages/ReportLanding");
          return { Component };
        },
      },
      {
        path: "security",
        lazy: async () => {
          const { default: Component } = await import("./pages/Security");
          return { Component };
        },
      },
      {
        path: "support",
        lazy: async () => {
          const { default: Component } = await import("./pages/Support");
          return { Component };
        },
      },
      {
        path: "integrations",
        lazy: async () => {
          const { default: Component } = await import("./pages/Integrations");
          return { Component };
        },
      },
      {
        path: "integrations/:slug",
        lazy: async () => {
          const { default: Component } = await import("./pages/IntegrationDoc");
          return { Component };
        },
        getStaticPaths: async () => {
          const { getIntegrationSlugs } = await import("./data/integrations");
          return getIntegrationSlugs().map((slug) => `/integrations/${slug}`);
        },
      },
      {
        path: "roi-calculator",
        lazy: async () => {
          const { default: Component } = await import("./pages/RoiCalculator");
          return { Component };
        },
      },
      {
        path: "verification-layer",
        lazy: async () => {
          const { default: Component } = await import("./pages/VerificationLayer");
          return { Component };
        },
      },
      {
        path: "unsubscribe",
        lazy: async () => {
          const { default: Component } = await import("./pages/Unsubscribe");
          return { Component };
        },
      },
      {
        path: "*",
        lazy: async () => {
          const { default: Component } = await import("./pages/NotFound");
          return { Component };
        },
      },
    ],
  },
];
